import React from 'react';
import { LightTooltip } from './LightTooltip';
import styles from './stockStyles';

export const EarningObject = ({ earningToolTip }) => {
	return (
		<LightTooltip placement='bottom' title={earningToolTip}>
			<div style={{ ...styles.EarningObject }}>
				<div style={{ padding: '2px  0px' }}>E</div>
			</div>
		</LightTooltip>
	);
};



// WEBPACK FOOTER //
// ./src/Pages/Stock/EarningObject.jsx